import styled from 'styled-components';

type TResponsive = {
  isMobile?: boolean;
  isDesktop?: boolean;
  isMediumSize?: boolean;
};

export type TDataSectionSecondary = {
  id: string,
  title: string;
  description: string;
  borderColor: string;
  iconColor: string;
  messageButton: string;
  imageUrl?: string;
  imageUrlMobile?: string;
  widthImageMobile: number;
  heightImageMobile: number;
  widthImageDesktop: number;
  heightImageDesktop: number;
  altImage: string;
};

export const Container = styled.div<TResponsive>`
  background: #f8f8f8;

  ${(props) =>
    props.isDesktop &&
    `
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: fit-content(100%);
    margin:auto;

    .left_aux_grid_1 {
      grid-column-start: 1; 
      grid-row-start: 1; 
    }

    .right_aux_grid_1 {
      grid-column-start: 3; 
      grid-row-start: 1; 
    }

    .left_aux_grid_9 {
      grid-column-start: 1; 
      grid-row-start: 9; 
    }

    .right_aux_grid_9 {
      grid-column-start: 3; 
      grid-row-start: 9; 
    }

    .left_aux_grid_7 {
      grid-column-start: 1; 
      grid-row-start: 7; 
    }

    .right_aux_grid_7 {
      grid-column-start: 3; 
      grid-row-start: 7; 
    }

    .section_content{
      grid-column-start: 2; 
    }
    
  `}
`;

export const AuxiliarySide = styled.div<{ height?; backgroundColor? }>`
  background-color: white;
  height: ${(props) => props.height || '517px'};
  background-color: ${(props) => props.backgroundColor || 'white'}; ;
`;

export const SectionPrimary = styled.div<TResponsive>`
  text-align-last: center;
  background: #ffffff;
  height: 488px;
  display: grid;
  margin-bottom: 96px;

  ${(props) =>
    props.isDesktop &&
    `  
    text-align-last: left;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-rows: fit-content(100%);
    column-gap:50px;    
    margin: auto;
    height: 517px;
    margin-bottom: 96px;
    column-gap: 103px;

    .grid_1 {
      order: 1;
      grid-column-start: 1; 
    }

    .grid_2 {
      order: 2;
      grid-column-start: 1; 
    }

    .grid_3 {
      order: 3;
      grid-column-start: 2; 
      grid-row-start: 1; 
      grid-row-end: 3; 
    }
  `}

  ${(props) =>
    props.isMediumSize &&
    `
    margin-bottom:115px;
  `}
`;

export const SectionSecondary = styled.div<TResponsive>`
  padding: 0 26px 96px 48px;

  ${(props) =>
    props.isDesktop &&
    `
    padding:0;
    margin-bottom:96px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-rows: fit-content(100%);
    column-gap: 103px;

    .grid_1 {
      order: 1;
      grid-column-start: 1; 
    }

    .grid_2 {
      order: 2;
      grid-column-start: 1; 
    }

    .grid_3 {
      order: 3;
      grid-column-start: 1; 
    }

    .grid_4 {
      order:4;
      grid-column-start: 2; 
      grid-row-start: 1; 
      grid-row-end: 4; 
    }
  `};

  ${(props) =>
    props.isMediumSize &&
    `
    display:grid;
    justify-content:center;
  padding: 0 26px 50px 48px;

  `};
`;

export const MainTitle = styled.h1<TResponsive>`
  width: 280px;
  height: fit-content;
  font-weight: 900;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: -0.024em;
  color: #000000;
  margin: auto;
  margin-bottom: 32px;
  padding-top: 54px;
  z-index: 10;

  ${(props) =>
    props.isDesktop &&
    `
  padding:0;
  width: 491px;
  font-size: 44px;
  line-height: 50px;
  display: flex;
  align-items: center;
  letter-spacing: -0.024em;
  text-align-last: left;
  align-items: start;
  margin-bottom: 96px;
  margin-top: 173px;

  @media screen and (max-height: 768px) {
    margin-top: 100px;
  }
`}

  ${(props) =>
    props.isMediumSize &&
    `
    width: 480px;
    font-size: 40px;
    text-align: center;
    line-height: 40px;
  `}
`;

export const BoxImageMain = styled.div<TResponsive>`
  text-align: center;
  height: max-content;
  position: relative;

  ${(props) =>
    props.isDesktop &&
    `
text-align: start;
margin-top: 96px;

@media screen and (max-height: 768px) {
  margin-top: 60px;
}
`}

  ${(props) =>
    props.isMediumSize &&
    `
  max-width: 306px;
  place-self: center;


`}
`;

export const Title = styled.h2<TResponsive>`
  width: 280px;
  height: fit-content;
  font-weight: 900;
  font-size: 30px;
  line-height: 34px;
  letter-spacing: -0.024em;
  color: #000000;
  margin-bottom: 32px;
  position: relative;

  ${(props) =>
    props.isDesktop &&
    `
    width: 491px;
    font-size: 44px;
    line-height: 50px;
    display: flex;
    align-items: center;
    letter-spacing: -0.024em;
    text-align-last: left;
    align-items: start;
  `}
`;

export const Description = styled.h3<TResponsive>`
  width: 280px;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.008em;
  color: #6c757d;
  margin: auto 0 32px 0;
  z-index: 10;

  ${(props) =>
    props.isDesktop &&
    `
    margin:0;
    margin-bottom: 24px;
    width: 100%;
  `}
`;

export const BoxButton = styled.div<TResponsive>`
  min-width: 328px;
  height: 144px;
  background: #ffffff;
  box-shadow: 0px 10px 25px rgba(120, 120, 120, 0.06);
  border-radius: 24px;
  padding: 24px;
  margin-top: 32px;
  margin-left: 16px;
  margin-right: 16px;
  display: grid;

  ${(props) =>
    props.isDesktop &&
    `
    margin-top: 14px;
    margin-left: 0;
    margin-right: 0;
    width: 389px;
  `}

  ${(props) =>
    props.isMediumSize &&
    `
    display:grid;
    margin-top: 0px;
    margin-left: 0px;
    margin-right: 0px;

  `}
`;

export const BoxImage = styled.div<TResponsive>`
  text-align: center;
  height: max-content;
  position: relative;

  ${(props) =>
    props.isDesktop &&
    `
  text-align: start;
  `}

  ${(props) =>
    props.isMediumSize &&
    `
    width:270px;
    `}
`;

export const BoxVideo = styled.div<TResponsive>`
  text-align: center;
  height: max-content;
  position: relative;

  ${(props) =>
    props.isDesktop &&
    `
  text-align: start;
  `}
`;

export const CirclePhoto = styled.div``;

export const CirclePlayVideo = styled.div<TResponsive>`
  position: absolute;
  width: 100px;
  display: inline-flex;
  left: 58%;
  top: 23%;

  ${(props) =>
    props.isDesktop &&
    `
    width: 150px;
    left: 181px;
    top: 54px;
  `}
`;

export const Play = styled.div<TResponsive>`
  position: absolute;
  z-index: 1;
  left: 5px;
  top: 5px;

  img {
    width: 75% !important;
  }

  &:hover {
    transform: scale(1.1);
    transition: 0.1s;
  }

  &:active {
    transform: scale(0.9);
    transition: 0.1s;
  }

  ${(props) =>
    props.isDesktop &&
    `
    left: 11px;
    top: 8px;

    img {
      width: 100% !important;
    }
  `}
`;

export const Border = styled.div<TResponsive>`
  position: absolute;
  img {
    width: 80% !important;
  }

  ${(props) =>
    props.isDesktop &&
    `
    img {
      width: 100% !important;
    }
  `}
`;

export const Message = styled.div<TResponsive>`
  font-weight: 900;
  font-size: 18px;
  letter-spacing: -0.008em;
  color: #6c757d;
  margin-bottom: 16px;
  float: left;
  justify-self: left;

  ${(props) =>
    props.isMediumSize &&
    `
    justify-self: center;
`}
`;

export const Item = styled.div<TResponsive>`
  ${(props) =>
    props.isMediumSize &&
    `
  width: 330px;
  margin:auto;
  }
`}
`;

export const LabelInformative = styled.div<{ color }>`
  color: ${(props) => props.color};
  a {
    color: #0055fb;
    text-decoration: underline;
    transition: 0.2s all ease;
    cursor: pointer;

    &:hover {
      font-size: 14.5px;
    }
  }
`;

export const BoxCallTenant = styled.div<TResponsive>`
  margin: auto 30px 64px 30px;
  display: flex;
  justify-content: center;

  ${(props) =>
    props.isDesktop &&
    `
    justify-content: space-between;
    margin: auto 40px 64px 40px;
    margin:0;
    margin-bottom: 161px;
    height: 56px;
  `}

  ${(props) =>
    props.isMediumSize &&
    `
    justify-content: center;
    margin: auto 30px 50px 30px;
  `}
`;

export const ItemInformative = styled.div`
  width: 390px;

  div {
    margin: auto;
  }
`;

export const ShowMore = styled.div`
  img {
    transition: 0.2s all ease-in-out;

    &:hover {
      cursor: pointer;
      transform: scale(1.1);
    }
  }
`;

export const GoToMore = styled.div<{ ref }>``;

export const LabelShowMore = styled.div`
  width: 100px;
  height: 5px;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: #9b9b9b;
`;

type ButtonLandlordProps = {
  borderColor: string;
  iconColor: string;
  background?: string;
};

export const ButtonLandlord = styled.button<ButtonLandlordProps & TResponsive>`
  padding: 12px 16px;
  box-sizing: border-box;
  border-radius: 24px;
  margin-bottom: 36px;
  background: ${(props) => props.background || '#f8f8f8'};
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  gap: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.2s all ease;
  z-index: 10;

  &:hover {
    box-shadow: 1px 1px 5px 0.5px #a6d7eb;
    transform: translate(5px);
  }

  ${(props) =>
    props.borderColor &&
    `
    border: 2px solid ${props.borderColor};
  `}

  ${(props) =>
    props.iconColor &&
    `
    svg {
      color: ${props.iconColor};
    }
  `};

  ${(props) =>
    props.isDesktop &&
    `
    height: 48px;
    width: max-content;
    margin:0;
  `}
`;

export type TDataCommentsLandlord = {
  namePerson: string;
  comment: string;
  star: number;
  checked: boolean;
  altImage: string;
};

export const SectionComments = styled.div<TResponsive>`
  height: 620px;
  background: #fff9eb;
  padding-left: 35px;
  padding-top: 40px;

  ${(props) =>
    props.isDesktop &&
    `
    padding:0;
    height: 673px;
    padding-top: 64px;
  `}
`;

export const LabelSection = styled.h3<TResponsive>`
  font-weight: 900;
  font-size: 22px;
  margin-bottom: 32px;
  line-height: 30px;
  letter-spacing: -0.024em;
  color: #555a64;
  text-align: center;

  ${(props) =>
    props.isDesktop &&
    `
  font-size: 24px;
  line-height: 36px;
`}

  ${(props) =>
    props.isMediumSize &&
    `
  text-align: center;
`}
`;

export const VoiceLandlord = styled.div<TResponsive>`
  display: flex;
  gap: 16px;

  .swiper {
    width: 100%;
    padding-bottom: 50px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
  }

  ${(props) =>
    props.isDesktop &&
    `
    float: left;

    .swiper-wrapper {
      place-content: center;
    }
  `}
`;

export const ContainerComment = styled.div`
  background: #ffffff;
  box-shadow: 0px 10px 25px rgba(120, 120, 120, 0.06);
  border-radius: 16px;
  padding: 32px 24px 24px 24px;
  width: 288px;
  height: 221px;
`;

export const LabelName = styled.div`
  display: flex;
  gap: 8px;
`;

export const NamePerson = styled.h4`
  height: 24px;
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.008em;
  color: #000000;
  margin-bottom: 8px;
`;

export const CommentPerson = styled.h5`
  height: max-content;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #6c757d;
  margin-bottom: 24px;
`;

export const BoxStars = styled.div`
  display: flex;
  gap: 8px;
`;

export type TDataArticlesJournalism = {
  logoJournalism: string;
  articleContent: string;
  articleUrl: string;
};

export const SectionArticles = styled.div<TResponsive>`
  padding-left: 35px;
  padding-top: 40px;

  ${(props) =>
    props.isDesktop &&
    `
    padding:0;
    height: 400px;
    padding-top: 64px;
`}

  ${(props) =>
    props.isDesktop &&
    `
   padding-top: 64px;
`}
`;

export const VoiceJournalism = styled.div<TResponsive>`
  display: flex;
  gap: 16px;

  .swiper {
    width: 100%;
    padding-top: 32px;
    padding-bottom: 50px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
  }

  ${(props) =>
    props.isDesktop &&
    `
    float:left;

    .swiper-wrapper {
      place-content: center;
    }
  `}
`;

export const ContainerArticle = styled.div`
  background: #ffffff;
  box-shadow: 0px 10px 25px rgba(120, 120, 120, 0.06);
  border-radius: 16px;
  padding: 32px 24px 24px 24px;
  width: 288px;
`;

export const ContentArticle = styled.h4`
  left: 24px;
  right: 24px;
  top: 84px;
  font-size: 16px;
  line-height: 24px;
  color: #555a64;
  margin-bottom: 21px;
`;

export const LinkArticle = styled.a``;

export const LabelReadMore = styled.div`
  height: 24px;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #0055fb;
  display: flex;
  gap: 9px;
`;

export const ModalVideo = styled.div<{ isOpenModal; isDesktop }>`
  display: ${(props) => props.isOpenModal || 'none'};
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 69px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 137px 15px 15px 15px;

  ${(props) =>
    props.isDesktop &&
    `
    padding: 40px 15px 60px 15px;
   `}
`;

export const CloseModalButton = styled.div<TResponsive>`
  position: absolute;
  top: 99px;
  right: 15px;
  color: white;
  font-size: 39px;

  &&:hover,
  &&:focus {
    text-decoration: none;
    cursor: pointer;
    transition: 0.3s ease;
  }

  ${(props) =>
    props.isDesktop &&
    `
    position: initial;
    width: 560px;
    margin: auto;
    text-align: right;
  `}
`;

export const SectionCalculator = styled.div<TResponsive>`
  height: 550px;
  background: #ebfaf1;
  padding-left: 35px;
  padding-top: 40px;

  ${(props) =>
    props.isDesktop &&
    `
    padding:0;
    height: 550px;
    padding-top: 64px;
  `}
`;

export const SectionKeyBox = styled(SectionSecondary)`
`;

export const KeyBoxItem = styled.div<TResponsive>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 12px;
  width: 280px;
  margin-bottom: 8px;
  ${(props) => props.isDesktop && 'width: 100%;'}

  & > svg {
    height: 16px;
    width: auto;
    flex-shrink: 0;
    color: #0055FB;
  }
`;

export const Descriptilon = styled.h3<TResponsive>`
  width: 280px;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.008em;
  color: #6c757d;
  margin: auto 0 32px 0;
  z-index: 10;

  ${(props) =>
    props.isDesktop &&
    `
    margin:0;
    margin-bottom: 24px;
    width: 100%;
  `}
`;

export const KeyBoxItemText = styled.p`
  margin: 0px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
`;

export const ContainerCalculator = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  gap: 32px;
`;

export const SectionPlans = styled.div<TResponsive>`
  height: 476px;
  padding-left: 35px;
  padding-top: 40px;

  ${(props) =>
    props.isDesktop &&
    `
    padding:0;
    height: 673px;
    padding-top: 64px;
  `}
`;

export const ContainerIsTenant = styled.div<{ isOpenTenantButton }>`
  display: ${(props) => props.isOpenTenantButton ? 'flex' : 'none'};
  flex-direction: row;
  position: fixed;
  z-index: 50;
  width: 100%;
  transform: translateY(-100%);
  animation-name: show;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-delay: 1000ms;

  @keyframes show {
    from {transform: translateY(-100%);}
    to {transform: translateY(0);}
  }
`;

export const SectionIsTenant = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 900px;
  position: relative;
  font-size: 14px;
  margin: auto;
  padding: 10px;
  align-items: center;
  background: #fff4d7;
  box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.01), 0px 5px 5px rgba(0, 0, 0, 0.01), 0px 1px 3px rgba(0, 0, 0, 0.01),
    0px 0px 0px rgba(0, 0, 0, 0.01);
  border-radius: 0px 0px 8px 8px;

  @media screen and (max-width: 600px){
    font-size: 12px;
  }
`;
